module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t2-2.fe1de790.svg";